// Stringify data and properly fence it in a markdown code block
function dataToMarkdownCodeBlock(data: unknown): string {
  const jsonContent = JSON.stringify(data);
  const longestBacktickSequence = jsonContent.match(/`+/g)?.reduce((max, seq) => Math.max(max, seq.length), 0) ?? 0;
  const fence = '`'.repeat(Math.max(longestBacktickSequence + 1, 3));
  return `${fence}json+McpResponse\n${jsonContent}\n${fence}`;
}

type Props = {
  id: string | number;
  /**
   * The tool name that was called. Surfaced in the result envelope so the
   * LLM can attribute results to calls when the assistant message that
   * issued the call is not in history.
   */
  name?: string;
  result?: unknown;
  error?: string;
};

export function toolResultToMarkdown({ id, name, result, error }: Props) {
  return dataToMarkdownCodeBlock({
    jsonrpc: '2.0',
    id,
    ...(name ? { call: { name } } : {}),
    ...(error ? { error } : { result }),
  });
}

export function createJsonRpcToolCallRequest(params: Record<string, unknown>, id: string | number) {
  return {
    type: 'MCP_CALL',
    payload: {
      jsonrpc: '2.0',
      id,
      method: 'tools/call',
      params,
    },
  };
}
